import { ArrowLeft } from 'lucide-react';
import { FC, Fragment, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { AssignmentGetAssignmentStudentDashboardQuery } from '../../graphQLOperations/__generated__/AssignmentGetAssignmentStudentDashboardQuery.graphql';
import { getAssignmentStudentDashboard } from '../../graphQLOperations/Assignment';
import { useLazyLoadQuery } from 'react-relay';
import { StudentDashboardAssignmentCard } from '../Dashboard/StudentDashboardAssignmentCard';
import { AssignmentItemList } from '../../models/Assignment';

// Dev notes:
// The previous version of this component used pagination
// (in subcomponents StudentCurrentAssignments and StudentPastAssignments)
// but we're removing the past assignments from view (since they're not actionable for the student),
// and the student is never expected to have more than ~10 current assignments (realstic numbers are 0, 1, or 2).
// Furthermore, scrolling is more user-friendly than pagination
// on modern browsers with content where load and rending time are not constratints.

export const StudentAssignments: FC = () => {
  const { assignments } = useLazyLoadQuery<AssignmentGetAssignmentStudentDashboardQuery>(
    getAssignmentStudentDashboard,
    {
      first: 100,
      order: [{ dueOn: 'ASC' }],
      filter: {
        startedOnTo: new Date(),
        dueOnFrom: new Date(),
        isActive: 'ACTIVE',
      },
    },
    { fetchPolicy: 'network-only' },
  );

  const currentAssignment = assignments?.nodes?.[0];
  const nextAssignments = assignments?.nodes?.slice(1) || [];
  useEffect(() => {
    document.title = `Teach to One Roadmaps | Teacher Assignments`;
  }, []);
  return (
    <div className="tw-p-8 tw-pb-16 tw-px-16">
      <Link
        to={'/'}
        className="tw-text-blue-500 tw-font-atkinson tw-text-base tw-font-bold tw-flex tw-items-center tw-gap-2 tw-bg-transparent tw-border-none tw-cursor-pointer tw-p-0 tw-mb-4"
      >
        <ArrowLeft className="tw-h-4 tw-rounded-full tw-inline-flex tw-justify-center tw-items-center tw-gap-2 tw-overflow-hidden" />
        Return to Unit
      </Link>
      <h1 className="tw-mt-4 tw-text-blue-500 tw-font-atkinson tw-text-xl">
        <b>Teacher assignments</b> ({assignments?.totalCount || 0})
      </h1>
      <h2 className="tw-font-bold tw-mt-8 tw-text-[14px] tw-not-italic tw-mb-2">Current</h2>{' '}
      {currentAssignment ? (
        <StudentDashboardAssignmentCard type="CURRENT" assignment={assignments.nodes[0] as AssignmentItemList} />
      ) : (
        <p>No current assignment</p>
      )}
      {nextAssignments.length > 0 && (
        <Fragment>
          <h2 className="tw-font-bold tw-mt-8 tw-text-[14px] tw-not-italic tw-mb-2">Next ({nextAssignments.length})</h2>
          {nextAssignments.map((assignment, index) => {
            return (
              <StudentDashboardAssignmentCard
                type="CURRENT"
                assignment={assignment as AssignmentItemList}
                key={index}
              />
            );
          })}
        </Fragment>
      )}
    </div>
  );
};
